import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-plus-light',
  templateUrl: './icon-plus-light.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconPlusLightComponent {}
